import { useState } from "react";
import { useNavigate } from "react-router-dom";

import API_URL from "../apiConfig";

import Seo from "../components/Seo";


function LoginPage() {

    const [username, setUsername] =
        useState("");

    const [password, setPassword] =
        useState("");

    const [error, setError] =
        useState("");

    const [isLoading, setIsLoading] =
        useState(false);


    const navigate =
        useNavigate();


    // ==================================================
    // LOGIN DURCHFÜHREN
    // ==================================================

    async function handleLogin(event) {

        event.preventDefault();


        if (isLoading) {
            return;
        }


        setError("");
        setIsLoading(true);


        try {

            const response =
                await fetch(
                    `${API_URL}/login.php`,
                    {
                        method: "POST",

                        credentials: "include",

                        headers: {
                            "Content-Type":
                                "application/json"
                        },

                        body: JSON.stringify({
                            username:
                                username.trim(),

                            password:
                                password
                        })
                    }
                );


            const data =
                await response.json();


            if (!response.ok) {

                throw new Error(
                    data.error ||
                    "Login fehlgeschlagen."
                );
            }


            localStorage.setItem(
                "token",
                data.token
            );


            localStorage.setItem(
                "username",
                data.username
            );


            navigate("/admin");


        } catch (error) {

            setError(
                error.message
            );


        } finally {

            setIsLoading(false);
        }
    }


    // ==================================================
    // AUSGABE
    // ==================================================

    return (

        <>

            <Seo
                title="Login"
                description="Anmeldung zum Administrationsbereich der persönlichen Webseite von Ivan Jörg."
                canonical="https://www.irj.ch/login"
                noIndex={true}
            />


            <div className="intro">

                <p>
                    Administration – Anmeldung
                </p>

            </div>


            <main>

                <section>

                    <h2>
                        Login
                    </h2>


                    <form
                        onSubmit={handleLogin}
                    >

                        <p>

                            <label>

                                Benutzername:

                                <br />

                                <input
                                    type="text"
                                    value={username}
                                    onChange={
                                        (event) =>
                                            setUsername(
                                                event.target.value
                                            )
                                    }
                                    required
                                />

                            </label>

                        </p>


                        <p>

                            <label>

                                Passwort:

                                <br />

                                <input
                                    type="password"
                                    value={password}
                                    onChange={
                                        (event) =>
                                            setPassword(
                                                event.target.value
                                            )
                                    }
                                    required
                                />

                            </label>

                        </p>


                        {
                            error && (

                                <p>
                                    {error}
                                </p>

                            )
                        }


                        <button
                            type="submit"
                            disabled={isLoading}
                        >

                            {
                                isLoading
                                    ? "Anmeldung läuft..."
                                    : "Anmelden"
                            }

                        </button>


                    </form>

                </section>

            </main>

        </>
    );
}


export default LoginPage;